import i18n from '../i18n/i18n'
import { store } from '../store'
import axios from 'axios'
import vuetifyToast from 'vuetify-toast'

export function apiConfig () {
  return axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: false,
    timeout: 35000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      lang: localStorage.getItem('langId') || '5bd9f3ee7fa5610014fed21e',
      Authorization: 'Bearer ' + getToken()
    }
  })
}

export function apiConfigLocal () {
  return axios.create({
    baseURL: `http://localhost:3005/v1/`,
    withCredentials: false,
    timeout: 15000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      lang: localStorage.getItem('langId') || '5bd9f3ee7fa5610014fed21e',
      Authorization: 'Bearer ' + getToken()
    }
  })
}

export function setApiToken (token) {
  apiAxios.defaults.headers['Authorization'] = `Bearer ${token}`
}

export function setApiLangId (langId) {
  apiAxios.defaults.headers['lang'] = langId
}

function getToken () {
  let result = localStorage.getItem('userToken')
  return result ? result.trim() : ''
}

const apiAxios = apiConfig()

/**
 * Se atrapan todos los errores de las llamadas de axios y se abre un toast informativo del error
 */
apiAxios.interceptors.response.use(
  function (response) {
    // if (process.env.NODE_ENV !== 'production') {
      if (response.data) {
        console.log('Response:', response.request.responseURL, response.data)
      }
    // }
    return response
  },
  function (error) {
    if (process.env.NODE_ENV !== 'production') console.log({ ...error })
    // handle error
    const { config, response } = error

    if (config && response && response.status === 401) {
      if (process.env.NODE_ENV !== 'production') console.log(response.data)

      let data = response.data || {}
      const errorMessage =
        data.error && data.error.reason
          ? data.error.reason
          : i18n.t('error.sessionExpired')

      vuetifyToast.show({
        text: errorMessage,
        color: 'error',
        timeout: 6000,
        icon: 'warning'
      })

      store.dispatch('authentication/logout')
    } else if (response) {
      // The request was made and the server responded with a status code hat falls out of the range of 2xx
      if (process.env.NODE_ENV !== 'production') console.log(response.data)

      let data = response.data || {}
      let errorMessage
      if (data.error && data.error.reason) {
        errorMessage =
          data.error.code !== 5000
            ? data.error.reason
            : i18n.t('error.messageNotDefined')
      } else errorMessage = i18n.t('error.messageNotDefined')

      vuetifyToast.show({
        text: errorMessage,
        color: 'error',
        timeout: 6000,
        icon: 'warning'
      })
    } else if (error.request) {
      // The request was made but no response was received
      // if (error.code === 'ECONNABORTED') {
      //   vuetifyToast.show({
      //     text: i18n.t('error.timeout'),
      //     color: 'error',
      //     timeout: 6000,
      //     icon: 'warning'
      //   })
      // } else {
      //   vuetifyToast.show({
      //     text: i18n.t('error.notConnection'),
      //     color: 'error',
      //     timeout: 6000,
      //     icon: 'warning'
      //   })
      // }
    } else {
      // Something happened in setting up the request that triggered an Error
      if (process.env.NODE_ENV !== 'production') {
        console.log('Error', error.message)
      }
      vuetifyToast.show({
        text: i18n.t('error.messageNotDefined'),
        color: 'error',
        timeout: 6000,
        icon: 'warning'
      })
    }
    return Promise.reject(error)
  }
)

apiAxios.interceptors.request.use(function (request) {
  // if (process.env.NODE_ENV !== 'production') {
    console.log('Request:', request.method, request.url, request.data || ' ')
  // }
  return request
})

export { apiAxios }
